export default {
  全部交易产品: "所有交易商品",
};
